export const toCategories = categories => {
  const sections = {}
  Object.keys(categories).forEach(categoryName => {
    sections[categoryName] = categories[categoryName].blocks.map(block =>
      toBlock(block, categories[categoryName].id, categories[categoryName].name)
    )
  })

  return sections
}

export const toBlock = (block, sectionId, sectionName) => {
  const { id, name, visible, system, type, content, createdBy, createdAt, updatedBy, updatedAt } =
    block
  return {
    id,
    name,
    category: { value: sectionId, label: sectionName },
    visible: visible ? 'everyone' : 'me',
    system,
    type,
    content,
    createdBy: createdBy ? `${createdBy.firstName} ${createdBy.lastName}` : '',
    createdAt,
    updatedBy: updatedBy ? `${updatedBy.firstName} ${updatedBy.lastName}` : '',
    updatedAt
  }
}
